import { useMemo } from "react";
import axios from "axios";
import { getPaymentColumns } from "../components/Order/paymentColumns";
import { API_BASE_URL } from '../api';
import useRangeMax from "./useRangeMax";

export default function usePaymentColumns({
    setPdfData,
    setShowPdfModal,
    setPageNumber,
    excludeColumns = []
}) {
    const amountMax = useRangeMax(`${API_BASE_URL}/api/v1/payments`, "amount");

    return useMemo(() => {
        const handleViewPdf = (id) => {
            axios.get(`${API_BASE_URL}/api/v1/payment/${id}/receipt`, {
                withCredentials: true,
                responseType: "blob",
            })
                .then((response) => {
                    const fileURL = URL.createObjectURL(
                        new Blob([response.data], { type: "application/pdf" })
                    );
                    setPdfData?.(fileURL);
                    setShowPdfModal?.(true);
                    setPageNumber?.(1);
                })
                .catch((error) => console.error("Erreur reçu PDF :", error));
        };

        let cols = getPaymentColumns({ handleViewPdf, amountMax });

        if (excludeColumns.length > 0) {
            cols = cols.filter(col => !excludeColumns.includes(col.accessor));
        }

        return cols;

    }, [setPdfData, setShowPdfModal, setPageNumber, excludeColumns, amountMax]);
}